module.exports = __webpack_public_path__ + "media/assets/images/landings/workforce/screens/nosco_planner_saturation-0add92bbb112a558f50d0173e4664c8f.png";